import { render } from "./LegacyAddEvents.vue?vue&type=template&id=2dd567a2"
import script from "./LegacyAddEvents.vue?vue&type=script&lang=js"
export * from "./LegacyAddEvents.vue?vue&type=script&lang=js"
script.render = render

export default script